import React from 'react'
import { useNavigate } from 'react-router-dom';

import { UilLinkAlt } from '@iconscout/react-unicons'
import '../App.css';
import carbonis from '../carbonis.png';

export default function Home() {
    const navigate = useNavigate();
    const goToDashboard = () => navigate('/dashboard-2');
    return (
        <div className="App">
            <div className="columns">
                <div className="column black-bg is-two-thirds">
                    <section className="section">
                        <img src={carbonis} style={{ height: '70px', marginBottom: '50px' }} />
                        <div className="container pad-3rem-l-r">
                            <h1 style={{ marginBottom: "10vh" }}><strong>WELCOME TO CARBONIS</strong></h1>
                            <p className="information">
                                CARBONIS is Web 3.0 platform and we invite users to sign up here. Each successfully signed up user will have a "CARBONIS Beta User NFT" airdrop in their registered Ethereum wallet, which will qualify these users for a new VIP membership draw by May 31, 2023. Each lucky user will be entitled to one of 1000 VIP NFTs. Each email and Ethereum wallet address is entitled to one CARBONIS Beta User NFT.

              </p>
                            <p className="is-center signup">
                                <button onClick={goToDashboard} className="button is-black margin-top-bottom-50"> <UilLinkAlt /> &nbsp;&nbsp; Connect Wallet </button>
                            </p>

                            <p style={{ position: 'fixed', bottom: '50px', fontSize: '17px' }}>
                                © 2022-2023 CARBONIS INC
              </p>

                        </div>
                    </section>
                </div>
                <div className="column">
                    <section className="section">
                        {/* <div className="buttons columns">
                            <div className="column"></div>
                            <div className="column"></div>
                            <div className="column"></div>
                            <div className="connect-wallet-top signup column">
                                <button onClick={goToDashboard} className="button is-black"> <UilLinkAlt /> &nbsp;&nbsp; Connect Wallet </button>
                            </div>
                        </div> */}
                        <div className="container">
                            {/* <h1 style={{ fontSize: "40px", fontWeight: "bold", textAlign: "center" }}>Welcome	to	Digital	Carbon</h1>
                            <p className="big-information">
                                Beta Tester Program
                            </p> */}
                            <p className="mid-information" style={{ backgroundColor: "#ffffff" }}>
                                <p className="legal">
                                    LEGAL DISCLAIMER
                            </p>
                                <p className="information" style={{ padding: "20px" }}>
                                    Nothing contained in the Web Site or the
                                    Tools is intended to constitute investment,
                                    legal, tax, accounting or other professional
                                    advice and you should not rely on the reports,
                                    data or other information provided on or
                                    accessible through the use of the Web Site for
                                    making financial decisions.
                            </p>
              </p>
                            {/* <p className="mid-information" style={{ fontWeight: "bold" }}>
                                This	website	is	for	exclusively	invited	Ethereum
                                wallet	owners	and	users	access	here	is	at	user's	risk
                                as	this	is	a	new	Web	3.0	Carbon	project	consulting
                                and	Carbon	financing	platform.
              </p> */}

                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}
